import React, { useEffect, useState } from 'react';
import { func, number, shape, string } from 'prop-types';
import { Pagination } from '@thd-olt-component-react/pagination';
import * as analytics from '../../ratings-reviews-analytics';
import { useProductDeprecated } from "@thd-nucleus/data-sources/react/dataModel/migration";
import { usePresentation } from '../../context/PresentationProvider';
import { params, string as stringType, shape as shapeType } from "@thd-nucleus/data-sources";

export const ReviewPager = ({ itemId, onPageChanged, reviewsPageContext }) => {
  const [pageContext, setPageContext] = useState(reviewsPageContext);
  const { useCondensedLayout } = usePresentation();
  useEffect(() => {
    onPageChanged(pageContext);
  }, [pageContext]);
  const { data, error, loading } = useProductDeprecated({ itemId, domains: ['identifiers', 'info'] });
  if ((error && !data) || !data || loading) {
    return null;
  }
  const seoLink = data?.product?.identifiers?.canonicalUrl?.replace('/p', '/p/reviews');
  const trackPaginationEvent = () => {
    analytics.track('event', {
      origin: 'ratings and reviews',
      location: 'pagination',
      eventType: 'click'
    });
  };

  const { totalPages = 1, currentPage = 1 } = pageContext || {};

  return (
    <Pagination
      channel={useCondensedLayout ? 'mobile' : 'desktop'}
      totalPages={totalPages}
      showArrows
      currentPage={currentPage}
      onPageChanged={(newPage) => {
        setPageContext({ ...pageContext, currentPage: newPage });
        trackPaginationEvent();
      }}
      href="?"
      noQueryParams
      queryHandler={(name, value) => {
        return {
          name: '',
          value: `${seoLink}/${value}`
        };
      }}
    />
  );
};

ReviewPager.displayNames = 'ReviewPager';

ReviewPager.propTypes = {
  itemId: string.isRequired,
  onPageChanged: func.isRequired,
  reviewsPageContext: shape({
    totalPages: number,
    currentPage: number,
    pageNeighbours: number
  }).isRequired
};

ReviewPager.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    identifiers: shapeType({
      canonicalUrl: stringType()
    })
  })
};
